import "./fabric.scss";
import { useEffect, useState } from "react";
import { axios } from "../../helpers";
import { useSelector } from "react-redux";
import { loginData } from "../../stores/auth";

const DetailFabricPage = (props) => {
  let [product, setProduct] = useState("");
  const dataLogin = useSelector(loginData);
  const getProduct = async () => {
    await axios
      .get("/v1/fabric/product", {
        headers: { Authorization: `Bearer ${dataLogin.data.token}` },
      })
      .then((res) => {
        res.data.data.map((item) => {
          if (item._id === props.data.product) {
            setProduct(item.name);
          }
        });
      });
  };
  useEffect(() => {
    getProduct();
  }, []);
  return (
    <div className="detail-fabric">
      <div className="detail-field">
        <div className="detail-key">Stock Code</div>
        <div className="detail-value">{props.data.stock_code}</div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Fabric Name</div>
        <div className="detail-value">{props.data.fabric_name}</div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Brand</div>
        <div className="detail-value">{props.data.brand}</div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Pattern</div>
        <div className="detail-value">{props.data.pattern}</div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Color</div>
        <div className="detail-value">{props.data.color}</div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Material</div>
        <div className="detail-value">{props.data.material}</div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Product</div>
        <div className="detail-value">{product}</div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Price</div>
        <div className="detail-value">{props.data.price}</div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Description</div>
        <div className="detail-value">{props.data.description}</div>
      </div>
      {/* <div className="detail-field">
        <div className="detail-key">Type</div>
        <div className="detail-value">
          {props.data.type.charAt(0).toUpperCase() + props.data.type.slice(1)}
        </div>
      </div> */}
      <div className="detail-field">
        <div className="detail-key">Fabric Image</div>
        <div className="detail-value">
          <img
            src={props.data.image}
            alt={props.data.fabric_name}
            style={{
              height: "120px",
              width: "150px",
              borderRadius: "32px",
              marginRight: "16px",
              objectFit: "cover",
            }}
          />
        </div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Status</div>
        <div className="detail-value">
          <div
            style={{
              padding: "4px 8px",
              borderRadius: "4px",
              color: props.data.status === "aktif" ? "#1EB200" : "white",
              backgroundColor:
                props.data.status === "aktif" ? "#D5FFCC" : "red",
            }}
          >
            {props.data.status === "aktif" ? "Active" : "Non-Active"}
          </div>
        </div>
      </div>
    </div>
  );
};
export default DetailFabricPage;
